<div class="container-fluid">
  <div class="col-md-12 m-t-50" style="text-align: center; color: #fff">
    <span class="f-22">Please wait....</span>
  </div>
  <div class="loader animation-start">
    <span class="circle delay-1 size-2"></span>
    <span class="circle delay-2 size-4"></span>
    <span class="circle delay-3 size-6"></span>
    <span class="circle delay-4 size-7"></span>
    <span class="circle delay-5 size-7"></span>
    <span class="circle delay-6 size-6"></span>
    <span class="circle delay-7 size-4"></span>
    <span class="circle delay-8 size-2"></span>
  </div>
</div>
